<div class="tw-flex-col">
  <span bitTypography="body2" class="tw-flex tw-text-muted">{{ title }}</span>
  <div class="tw-flex tw-items-baseline tw-gap-2">
    <span bitTypography="h1">{{ value }}</span>
    <span bitTypography="body2">{{ "cardMetrics" | i18n: maxValue }}</span>
  </div>
</div>
